<template>
  <div :style="lineCss"></div>
</template>
<script>
  export default {
    name: 'ReportLine',
    computed: {
      lineCss () {
        return {
          // position: 'absolute',
          // borderBottom: '2px dotted #ada000',
          borderBottom: '1px dotted #555',
          fontSize: '16px',
          left: '0in'
        }
      }
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// ReportLine.vue?4107d9e0